"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var padStart = function padStart(string, maxLength, fillString) {
  var stringLength = string.length;
  var truncatedStringFiller = repeat(fillString, Math.ceil(maxLength / stringLength + 1)).slice(0, maxLength - stringLength);
  return truncatedStringFiller + string;
};

var repeat = function repeat(string, count) {
  var T = "";

  for (var i = 0; i < count; i++) {
    T += string;
  }

  return T;
};

exports.createHex = function (_ref) {
  var red = _ref.red,
      green = _ref.green,
      blue = _ref.blue,
      _ref$alpha = _ref.alpha,
      alpha = _ref$alpha === void 0 ? 255 : _ref$alpha;
  var redHex = padStart(red.toString(16), 2, "0");
  var greenHex = padStart(green.toString(16), 2, "0");
  var blueHex = padStart(blue.toString(16), 2, "0");
  var alphaHex = padStart(alpha.toString(16), 2, "0");
  return "#".concat(alphaHex).concat(redHex).concat(greenHex).concat(blueHex);
};

exports.createCssRgb = function (_ref2) {
  var red = _ref2.red,
      green = _ref2.green,
      blue = _ref2.blue,
      _ref2$alpha = _ref2.alpha,
      alpha = _ref2$alpha === void 0 ? 255 : _ref2$alpha;
  return "rgba(".concat(red, ", ").concat(green, ", ").concat(blue, ", ").concat(alpha / 255, ")");
};

exports.brightness = function (_ref3) {
  var red = _ref3.red,
      green = _ref3.green,
      blue = _ref3.blue;
  var redPart = 0.2126 * (red / 255);
  var greenPart = 0.7152 * (green / 255);
  var bluePart = 0.0722 * (blue / 255);
  return redPart + greenPart + bluePart;
};

exports.overlay = function () {
  var finalColor = {
    red: 0,
    green: 0,
    blue: 0,
    alpha: 255
  };

  for (var _len = arguments.length, colors = new Array(_len), _key = 0; _key < _len; _key++) {
    colors[_key] = arguments[_key];
  }

  for (var _i = 0, _colors = colors; _i < _colors.length; _i++) {
    var color = _colors[_i];

    if (color.alpha === 0) {
      continue;
    }

    if (color.alpha === 255) {
      finalColor.red = color.red;
      finalColor.green = color.green;
      finalColor.blue = color.blue;
    }

    var red = color.red,
        green = color.green,
        blue = color.blue;
    var alpha = color.alpha / 255;
    finalColor.red = alpha * (red - finalColor.red) + finalColor.red;
    finalColor.green = alpha * (green - finalColor.green) + finalColor.green;
    finalColor.blue = alpha * (blue - finalColor.blue) + finalColor.blue;
  }

  finalColor.red = Math.round(finalColor.red);
  finalColor.green = Math.round(finalColor.green);
  finalColor.blue = Math.round(finalColor.blue);
  return finalColor;
};

exports.parseHex = function (hex) {
  if (hex[0] !== "#") {
    return null;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = hex.slice(1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _char = _step.value;

      if (!("a" <= _char && _char <= "f") && !("A" <= _char && _char <= "F") && !("0" <= _char && _char <= "9")) {
        return null;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var hexLength = hex.length;

  if (hexLength === "#rgb".length) {
    return {
      red: parseInt(repeat(hex.slice(1, 2), 2), 16),
      green: parseInt(repeat(hex.slice(2, 3), 2), 16),
      blue: parseInt(repeat(hex.slice(3, 4), 2), 16),
      alpha: 255
    };
  }

  if (hexLength === "#argb".length) {
    return {
      red: parseInt(repeat(hex.slice(2, 3), 2), 16),
      green: parseInt(repeat(hex.slice(3, 4), 2), 16),
      blue: parseInt(repeat(hex.slice(4, 5), 2), 16),
      alpha: parseInt(repeat(hex.slice(1, 2), 2), 16)
    };
  }

  if (hexLength === "#rrggbb".length) {
    return {
      red: parseInt(hex.slice(1, 3), 16),
      green: parseInt(hex.slice(3, 5), 16),
      blue: parseInt(hex.slice(5, 7), 16),
      alpha: 255
    };
  }

  if (hexLength === "#aarrggbb".length) {
    return {
      red: parseInt(hex.slice(3, 5), 16),
      green: parseInt(hex.slice(5, 7), 16),
      blue: parseInt(hex.slice(7, 9), 16),
      alpha: parseInt(hex.slice(1, 3), 16)
    };
  }

  return null;
};

var generalRgbConversionData = function generalRgbConversionData(rgbColor) {
  var red = rgbColor.red / 255;
  var green = rgbColor.green / 255;
  var blue = rgbColor.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var delta = max - min;
  var hue = 60;

  if (max === min) {
    hue = 0;
  } else if (max === red) {
    hue *= (green - blue) / delta;
  } else if (max === green) {
    hue *= 2 + (blue - red) / delta;
  } else if (max === blue) {
    hue *= 4 + (red - green) / delta;
  }

  if (hue < 0) {
    hue += 360;
  }

  return {
    max: max,
    min: min,
    delta: delta,
    hue: hue
  };
};

var toRgb = function toRgb(_ref4) {
  var chroma = _ref4.chroma,
      x = _ref4.x,
      match = _ref4.match,
      alpha = _ref4.alpha,
      hue = _ref4.hue;
  var red = 0,
      green = 0,
      blue = 0;

  if (0 <= hue && hue < 60) {
    red = chroma;
    green = x;
    blue = 0;
  } else if (60 <= hue && hue < 120) {
    red = x;
    green = chroma;
    blue = 0;
  } else if (120 <= hue && hue < 180) {
    red = 0;
    green = chroma;
    blue = x;
  } else if (180 <= hue && hue < 240) {
    red = 0;
    green = x;
    blue = chroma;
  } else if (240 <= hue && hue < 300) {
    red = x;
    green = 0;
    blue = chroma;
  } else if (300 <= hue) {
    red = chroma;
    green = 0;
    blue = x;
  }

  return {
    red: Math.round((red + match) * 255),
    green: Math.round((green + match) * 255),
    blue: Math.round((blue + match) * 255),
    alpha: alpha
  };
};

exports.rgbToHsl = function (rgbColor) {
  var _generalRgbConversion = generalRgbConversionData(rgbColor),
      max = _generalRgbConversion.max,
      min = _generalRgbConversion.min,
      delta = _generalRgbConversion.delta,
      hue = _generalRgbConversion.hue;

  var lightness = (max + min) / 2;
  var saturation = delta / (1 - Math.abs(2 * lightness - 1)) || 0;
  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness,
    alpha: rgbColor.alpha
  };
};

exports.hslToRgb = function (_ref5) {
  var hue = _ref5.hue,
      saturation = _ref5.saturation,
      lightness = _ref5.lightness,
      alpha = _ref5.alpha;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var x = chroma * (1 - Math.abs(hue / 60 % 2 - 1));
  var match = lightness - chroma / 2;
  return toRgb({
    chroma: chroma,
    x: x,
    match: match,
    alpha: alpha,
    hue: hue
  });
};

exports.rgbToHsb = function (rgbColor) {
  var _generalRgbConversion2 = generalRgbConversionData(rgbColor),
      max = _generalRgbConversion2.max,
      delta = _generalRgbConversion2.delta,
      hue = _generalRgbConversion2.hue;

  var saturation = 0;

  if (max !== 0) {
    saturation = delta / max;
  }

  var brightness = max;
  return {
    hue: hue,
    saturation: saturation,
    brightness: brightness,
    alpha: rgbColor.alpha
  };
};

exports.hsbToRgb = function (_ref6) {
  var hue = _ref6.hue,
      saturation = _ref6.saturation,
      brightness = _ref6.brightness,
      alpha = _ref6.alpha;
  var chroma = brightness * saturation;
  var x = chroma * (1 - Math.abs(hue / 60 % 2 - 1));
  var match = brightness - chroma;
  return toRgb({
    chroma: chroma,
    x: x,
    match: match,
    alpha: alpha,
    hue: hue
  });
};

exports.isLight = function (color) {
  return exports.brightness(color) > 0.6;
};

exports.isDark = function (color) {
  return !exports.isLight(color);
};